import React, { useState, useEffect } from "react"
import BusinessBootcampFAQs from "./BusinessBootcampFAQs"
import BusinessHero from "../../business-programs/_components/BusinessHero"
import CEOVideo from "./CEOVideo"
import Message from "../_components/Message"
import PriceBlock from "../_components/PriceBlock"
import ProgramFeatures from "../_components/ProgramFeatures"
import ProgramOverview from "../_components/ProgramOverview"
import Questions from "../_components/Questions"
import WhySection from "../_components/WhySection"
import { Button } from "../../../components/ui/button"
import { SvgZoeeLogoColored } from "../../../components/icons"
import { useIntercom } from "react-use-intercom"
import { useLocation, useNavigate } from "react-router-dom"

const BusinessBootcampPage: React.FC = () => {
  const { shutdown } = useIntercom()
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
  })
  const location = useLocation()
  const isBootcamp = location.pathname
    .toLowerCase()
    .startsWith("/5daybusinessbootcamp")
  const pathname = useLocation().pathname.split("/")[1]
  const navigate = useNavigate()
  const handleBootcampRegistration = () => {
    navigate("/5daybusinessbootcamp/registration")
  }

  const handleJoinWaitlist = () => {
    window.open("https://form.jotform.com/253005569459161", "_blank")
  }

  useEffect(() => {
    shutdown()
  }, [shutdown])

  useEffect(() => {
    // Midnight ET March 13, 2026
    const targetDate = new Date("2026-03-14T04:00:00Z").getTime()
    const updateCountdown = () => {
      const now = new Date().getTime()
      const timeLeft = targetDate - now

      if (timeLeft > 0) {
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24))
        const hours = Math.floor(
          (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        )
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
        setCountdown({ days, hours, minutes })
      } else {
        setCountdown({ days: 0, hours: 0, minutes: 0 })
      }
    }
    updateCountdown()
    const interval = setInterval(updateCountdown, 60000)
    return () => clearInterval(interval)
  }, [])

  const isCountdownActive =
    !!countdown &&
    (countdown.days > 0 || countdown.hours > 0 || countdown.minutes > 0)

  return (
    <div className="w-full overflow-x-hidden">
      <div className="w-full px-4 py-3  flex justify-center items-center ">
        <div className="w-full max-w-6xl px-6 py-3  rounded-[20px] shadow-lg flex justify-between items-center">
          <div
            className="ml-4 sm:ml-4 flex items-center cursor-pointer"
            onClick={() => navigate("/")}
          >
            <SvgZoeeLogoColored className="h-6 md:w-auto md:mr-6 sm:-ml-0 -ml-6" />{" "}
          </div>

          <div className="hidden sm:flex sm:items-center sm:gap-2 md:gap-4">
            {countdown.days === 0 &&
            countdown.hours === 0 &&
            countdown.minutes === 0 ? (
              <div className="text-black text-xl">REGISTRATION IS CLOSED</div>
            ) : (
              <>
                {[
                  { value: countdown.days, label: "Days" },
                  { value: countdown.hours, label: "Hours" },
                  { value: countdown.minutes, label: "Minutes" },
                ].map(({ value, label }, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <div className="text-black text-xl font-bold">{value}</div>
                    <div className="text-black text-xl font-normal">
                      {label}
                    </div>
                  </div>
                ))}
                <div className="hidden lg:inline-block text-black text-xl font-normal">
                  LIMITED TIME OFFER
                </div>
              </>
            )}
          </div>

          <Button
            variant="default"
            className="bg-[#4750f5] text-white px-6 py-2 rounded-lg text-base font-bold"
            onClick={
              isCountdownActive
                ? handleBootcampRegistration
                : handleJoinWaitlist
            }
          >
            {isCountdownActive ? (
              <>
                <span className="hidden sm:block">SAVE MY SEAT</span>
                <span className="block sm:hidden">SAVE MY SEAT</span>
              </>
            ) : (
              <>
                <span className="hidden sm:block">JOIN WAITLIST</span>
                <span className="block sm:hidden">JOIN WAITLIST</span>
              </>
            )}
          </Button>
        </div>
      </div>
      <BusinessHero
        pathname={pathname}
        isBootcamp={isBootcamp}
        isCountdownActive={isCountdownActive}
      />
      <CEOVideo />
      <Questions
        pathname={pathname}
        isBootcamp={isBootcamp}
        isCountdownActive={isCountdownActive}
      />
      <ProgramFeatures
        pathname={pathname}
        isBootcamp={isBootcamp}
        isCountdownActive={isCountdownActive}
      />
      <ProgramOverview
        isBootcamp={isBootcamp}
        isCountdownActive={isCountdownActive}
      />
      <WhySection isBootcamp={isBootcamp} />
      <PriceBlock
        pathname={pathname}
        isBootcamp={isBootcamp}
        isCountdownActive={isCountdownActive}
      />
      <Message isBootcamp={isBootcamp} />
      <BusinessBootcampFAQs />
    </div>
  )
}

export default BusinessBootcampPage
